<!-- @format -->

<ng-container *transloco="let t">
  <fudis-grid [columns]="12" [width]="'initial'" [columnGap]="'sm'" [rowGap]="'sm'">
    <!--
      The grid-column values below are intentionally identical to app-total-credits,
      so that the module totals line up with the plan selector. Note this, if you make changes.
      -->
    <fudis-select
      data-cy="plan-selector"
      fudisGridItem
      [columns]="{ xs: 'stretch', md: '1 / 7', xl: '1 / 6', xxl: '1 / 5' }"
      [control]="selectPlanControl"
      [label]="t('ENTITY_NAMES.plan')"
      [selectionClearButton]="false"
      (selectionUpdate)="selectPlan.emit($event.value)">
      <ng-template fudisSelectOptions>
        @for (key of Object.keys(mappedPlanStructure); track key) {
          <fudis-select-group [label]="(key | education | async)?.name | localizedString">
            @for (option of mappedPlanStructure[key]; track option) {
              <fudis-select-option
                [data]="{
                  value: option.id,
                  label: option.name + (option.primary ? ' (' + t('PRIMARY_STUDY_PLAN') + ')' : ''),
                  subLabel: t('STUDY_PLAN_SELECTOR_SUB_TEXT', {
                    learningOpportunityName:
                      option.learningOpportunityId | learningOpportunityName: (key | education | async) | localizedString,
                    curriculumPeriodName: option.curriculumPeriodId | curriculumPeriodName | async,
                    modified: option.metadata.lastModifiedOn | localDateFormat,
                  }),
                }">
              </fudis-select-option>
            }
          </fudis-select-group>
        }
      </ng-template>
    </fudis-select>
    @if (currentPlan) {
      <app-plan-header-info-list
        fudisGridItem
        [columns]="{ xs: 'stretch', lg: '7 / 13', xl: '6 / 12' }"
        [currentPlan]="this.currentPlan"></app-plan-header-info-list>
    }
    @if (menuOptions) {
      <sis-menu-button
        fudisGridItem
        [columns]="{ xs: 'stretch', md: '12 / 13' }"
        [alignSelfX]="'end'"
        [alignSelfY]="'start'"
        [id]="'planMenuOptionsButton'"
        [color]="'primary'"
        [options]="menuOptions"
        data-cy="plan-menu-options-button">
        <sis-icon [icon]="'three-dots'"></sis-icon>
      </sis-menu-button>
    }
  </fudis-grid>
  @if (showHorizontalRule) {
    <hr class="sis-hr" />
  }
</ng-container>
